import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { onRowLeave } from '@bringg-frontend/monitoring-shared';

import PlanningTag from 'bringg-web/features/monitoring/routes-monitoring-screen/monitoring-table/cells-renderers/routes-identifier/components/planning-tag/planning-tag';
import useActionItems from 'bringg-web/features/monitoring/shared/hooks/use-action-items';
import { View } from 'bringg-web/features/monitoring/shared/types';
import ActionsMenu from '../../../routes-monitoring-screen/monitoring-table/cells-renderers/routes-identifier/components/actions-menu/actions-menu';
import useIsRowHover from 'bringg-web/features/monitoring/shared/hooks/use-is-row-hover';
import useOrderExplorerStore from '../../stores/use-order-explorer-store';

const RouteGroupTags = ({ routeId, groupId }: { routeId: number; groupId: string }) => {
	const [shouldPresentTag, setShouldPresentTag] = useState(false);
	const [isActionMenuLoading, setIsActionMenuLoading] = useState(false);

	const setIsMenuLoading = (isLoading: boolean) => {
		setIsActionMenuLoading(isLoading);
		if (!isLoading) {
			onRowLeave(groupId);
		}
	};
	const { actionItems } = useActionItems(routeId, View.tasks, setIsMenuLoading);
	const hovered = useIsRowHover(groupId);

	const {
		orderExplorerStore: { currentTableDefinition }
	} = useOrderExplorerStore();

	const { flatTableItems } = currentTableDefinition;

	useEffect(() => {
		checkIfShouldPresentTag();
	}, [routeId, flatTableItems]);

	const checkIfShouldPresentTag = () => {
		const route = getRootEnv().dashboardSdk.sdk.v2.runs.get(routeId);
		if (route) {
			const routeTasks = getRootEnv().dashboardSdk.sdk.v2.tasks.getMany(route.task_ids);
			const isThereTaskNotDonePlanning = routeTasks.length ? routeTasks.some(task => !task.planning_done) : true;
			setShouldPresentTag(!route.ready_to_execute && !isThereTaskNotDonePlanning);
		}
	};

	return (
		<>
			{shouldPresentTag && <PlanningTag routeId={routeId} />}
			{((hovered && actionItems.length) || isActionMenuLoading) && (
				<ActionsMenu items={actionItems} onSelect={() => onRowLeave(groupId)} isLoading={isActionMenuLoading} />
			)}
		</>
	);
};

export default observer(RouteGroupTags);
